<template>
  <v-autocomplete
    ref="auditor"
    v-model="selected"
    :items="items"
    :item-text="text"
    item-value="uuid"
    :label="title"
    :rules="rules"
    :required="required"
    :disabled="disabled"
    :readonly="readonly"
    :dense="dense"
    @change="onChange($event)"
  ></v-autocomplete>
</template>

<script>
export default {
  name: 'SelectAuditores',
  props: {
    value: String,
    title: { type: String, default: 'Auditor' },
    dense: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    filtAlcanceUuid: { type: String, default: null },
    filtAuditorTipo: { type: String, default: null },
  },
  mounted() {
    if (this.required) this.rules = [(v) => !!v || 'Obligatorio']
    this.getItems()
  },
  data(ctx) {
    return {
      rules: [],
      selected: ctx.value,
      items: [],
    }
  },
  watch: {
    value(val) {
      if (!val || val === '') this.$refs.auditor.reset()
      this.selected = val
    },
    filtAlcanceUuid() {
      this.getItems()
    },
    filtAuditorTipo() {
      this.getItems()
    },
  },
  computed: {
    offlineMode() {
      return this.$store.getters['auditorias/offlineMode']
    },
  },
  methods: {
    text(item) {
      let nombre = item.nombre
      if (item.primer_apellido) nombre += ' ' + item.primer_apellido
      if (item.segundo_apellido) nombre += ' ' + item.segundo_apellido
      if (item.apellidos) nombre += ' ' + item.apellidos
      return nombre
    },
    async getItems() {
      if (this.offlineMode) {
        const storage = JSON.parse(localStorage.getItem('auditores'))
        this.items = storage
      } else {
        const res = await this.$store.dispatch('auditores/list')
        console.log('res en select: ', res)
        if (!res) return
        
        const hoy = new Date().toISOString().substr(0, 10)
        const formatDate = (d) => new Date(d).toISOString().slice(0, 10)
        this.items = res.filter((auditor) => {
          if (!auditor.user?.activo) return false
          if (this.$auth.user.empresa.nombre == 'Ccl') {
            if (this.filtAlcanceUuid || this.filtAuditorTipo) {
              return auditor.afinidades.some((af) => {
                const alcanceUuid = af.alcance
                const nivel = af.nivel
                const desde = af.desde || '0000-01-01'
                const hasta = af.hasta || '9999-12-31'
                const desdeStr = formatDate(desde)
                const hastaStr = formatDate(hasta)
                const matchesAlcance = this.filtAlcanceUuid ? alcanceUuid === this.filtAlcanceUuid : true
                const matchesTipo = this.filtAuditorTipo ? nivel === this.filtAuditorTipo : true
                const isActive = hoy >= desdeStr && hoy <= hastaStr
                return matchesAlcance && matchesTipo && isActive
              })
            }
          }
          return true
        })
      }
    },
    onChange(event) {
      this.$emit('input', event)
      this.$emit('change', event)
    },
  },
}
</script>
